module.exports = __webpack_public_path__ + "img/PM.01fb6bb3.jpeg";